module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8753/img/hubspot-tools-logo.png"